module.exports = "<nav class=\"navbar\">\n  <div class=\"logo\">\n    <h1><a ui-sref=\"home\">{{ vm.name }}</a></h1>\n  </div>\n  <div class=\"nav-links\">\n    <span><a ui-sref=\"about\">about</a></span>\n  </div>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/navbar/navbar.html
// module id = 7
// module chunks = 0